import { isTasksEnabled, isMonitoringEnabled } from "@/services/config";

const patientRoutes = [
  {
    path: "/patient",
    component: () =>
      import(/* webpackChunkName: "patient" */ "../layouts/PatientLayout.vue"),
    children: [
      {
        path: "/patient",
        name: "patient",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/PatientList.vue"
          ),
      },
      {
        path: "/patient/create",
        name: "create-patient",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/PatientDetail.vue"
          ),
      },
      {
        path: "/patient/sacar-turno",
        redirect: { name: "patient-turnos" },
      },
      // ────────────────────────────────────────────────────────────────────
      // Rutas de path estático que comparten prefijo con `/patient/:id` —
      // tienen que ir ANTES del dynamic `:id` route, porque Vue Router 3
      // matchea por orden y `/patient/:id` capturaría `/patient/turnos`
      // como `id="turnos"` y montaría PatientDetail (editor del doctor).
      // Bug encontrado 2026-05-09 al embeber `/patient/turnos` en mobile
      // WebView: navegar por path string (vs por route name) disparaba el
      // match equivocado y terminaba siempre en historia clínica.
      // ────────────────────────────────────────────────────────────────────
      {
        path: "/patient/me",
        name: "patient-me",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/dashboard/PatientDashboard.vue"
          ),
      },
      {
        path: "/patient/turnos",
        name: "patient-turnos",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../views/patient/Turnos.vue"
          ),
      },
      {
        path: "/patient/appointments",
        redirect: { name: "patient-turnos" },
      },
      {
        path: "/patient/credential",
        name: "patient-credential",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/PatientCredential.vue"
          ),
      },
      {
        path: "/patient/monitoring",
        name: "patient-monitoring",
        meta: { condition: () => isMonitoringEnabled },
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/dashboard/PatientMonitoring.vue"
          ),
      },
      // ────────────────────────────────────────────────────────────────────
      // Dynamic `:id` route — DESPUÉS de las rutas estáticas con prefijo
      // `/patient/`. Las rutas con `:id` extra de path (treatment, dashboard,
      // tasks, sales) van al final también — son inherentemente más
      // específicas que `/patient/:id` solo.
      // ────────────────────────────────────────────────────────────────────
      {
        path: "/patient/:id",
        name: "update-patient",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/PatientDetail.vue"
          ),
      },
      {
        path: "/patient/:id/treatment",
        name: "assign-treatment-patient",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/PatientTreatmentDetail.vue"
          ),
      },
      {
        path: "/patient/:id/dashboard",
        name: "patient-dashboard",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/dashboard/PatientDashboard.vue"
          ),
      },
      {
        path: "/prescription/:indicationId/purchase",
        name: "prescription-purchase",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/PrescriptionPurchase.vue"
          ),
      },
      {
        path: "/patient/:id/tasks",
        name: "patient-tasks",
        meta: { enabled: isTasksEnabled },
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/PatientTasks.vue"
          ),
        children: [
          {
            path: ":taskType/create",
            name: "create-patient-task",
            component: () =>
              import(
                /* webpackChunkName: "patient" */ "../components/task/TaskDetail.vue"
              ),
          },

          {
            path: ":taskType/:taskID",
            name: "update-patient-task",
            component: () =>
              import(
                /* webpackChunkName: "patient" */ "../components/task/TaskDetail.vue"
              ),
          },
        ],
      },
      {
        path: "/patient/:id/sales",
        name: "sales-list",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/dashboard/sales/SalesList.vue"
          ),
      },
      {
        path: "/print",
        name: "event-print",
        component: () =>
          import(
            /* webpackChunkName: "patient" */ "../components/patient/printing/FormPrint.vue"
          ),
      },
    ],
  },
];

export default patientRoutes;
